export const ManualFormHash = {
  BASIC: "basic",
  PLAN: "plan",
  // ACCOUNT_PROPERTY: "account-property",
} as const;

export type FormKey = (typeof ManualFormHash)[keyof typeof ManualFormHash];
